import BaseProtocol from './BaseProtocol';
import { ROLES_AND_RESPONSIBILITIES_ITEMS } from './rolesAndResponsibilitiesConstants';

const RolesAndResponsibilities = ({ positionId, targetUserId, onClose }) => (
    <BaseProtocol
        role={positionId?.toUpperCase()}
        title="Roles and Responsibilities"
        items={ROLES_AND_RESPONSIBILITIES_ITEMS}
        apiEndpoint="/roles-and-responsibilities"
        fetchEndpoint="/roles-and-responsibilities"
        targetUserId={targetUserId}
        defaultValues={{
            userId: targetUserId
        }}
        onClose={onClose}
    />
);

export default RolesAndResponsibilities;
